import { type WebFlowCollectionItem } from "@tudigo-monorepo/core-tudigo-api-models";

import type { WebflowTestimonial } from "../models/webflow-testimonial";

export function formatWebflowItemTestimonialData(
  item: WebFlowCollectionItem,
): WebflowTestimonial {
  return {
    id: item.id,
    quote: item.fieldData?.quoteAffichee,
    canDisplay:
      !item.isArchived && !item.isDraft && !!item.fieldData?.affichageSurLaHome,
    displayPosition: item.fieldData?.positionDAffichage,
    investor: {
      shortName: item.fieldData?.nomAbrege,
      description: item.fieldData?.motifInvestissements,
      thumbnailUrl: item.fieldData?.portraitInterviewe?.url,
    },
    previewVideo: {
      type: "video",
      data: {
        iframeUrl: item.fieldData?.["placeholderVideo-LienVersLaBoucleDe3s"],
        title: item.fieldData?.videoAssociee?.metadata.title,
        platform: item.fieldData.videoAssociee?.metadata.providerName,
      },
    },
    fullVideoEmbedHTML: item.fieldData.videoAssociee?.metadata.html,
  };
}
